var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import Errors from "../shared/errors";
import Busy from "../shared/busy";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import ErrorService from "../../src/Services/Shared/Error.service";
import { getXSRF } from "../../src/Services/Shared/FetchService";
export default class AlertCoordinatorAdd extends PureComponent {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // @ts-expect-error - TS2416 - Property 'state' in type 'AlertCoordinatorAdd' is not assignable to the same property in base type 'PureComponent<Props, State, any>'.
        this.state = {
            selectedEarlyAlertReason: null,
            selectedLocation: null,
            selectedCoordinator: null,
            errors: [],
            isLoadingEarlyAlertReasons: false,
            isSaving: false,
            validationErrors: [],
        };
        // @ts-expect-error - TS7006 - Parameter 'earlyAlertReason' implicitly has an 'any' type.
        this.onEarlyAlertReasonChange = (earlyAlertReason) => {
            this.setState({ selectedEarlyAlertReason: earlyAlertReason });
        };
        this.onEvent = this.onEvent.bind(this);
        this.onLocationChange = this.onLocationChange.bind(this);
        this.onCoordinatorChange = this.onCoordinatorChange.bind(this);
        this.save = this.save.bind(this);
    }
    componentDidMount() {
        this.loadEarlyAlertReasons();
    }
    onEvent(eventData) {
        console.log("event published", eventData);
    }
    loadEarlyAlertReasons() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoadingEarlyAlertReasons: true });
                const response = yield this.fetchEarlyAlertReasons();
                if (response.success) {
                    // @ts-expect-error - TS2345 - Argument of type '{ earlyAlertReasons: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
                    this.setState({ earlyAlertReasons: response.data });
                }
                else {
                    this.onError(`Error loading staff initiated alert reasons: ${response.message}`);
                }
            }
            catch (error) {
                this.onError(error);
            }
            finally {
                this.setState({ isLoadingEarlyAlertReasons: false });
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'inputValue' implicitly has an 'any' type.
    fetchLocations(inputValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/location/list?format=json&query=${encodeURIComponent(inputValue)}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return { options: responseJson.data };
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedLocation' implicitly has an 'any' type.
    onLocationChange(selectedLocation) {
        if (selectedLocation) {
            this.setState({ selectedLocation });
        }
        else {
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'LookupItem[]'.
            this.setState({ selectedLocation: null });
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'inputValue' implicitly has an 'any' type.
    fetchStaff(inputValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/alert/getEligibleRecipients?searchText=${inputValue}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            // studentId is set as the affiliation.institutionPersonId in personDto.
            // @ts-expect-error - TS7006 - Parameter 'staffMember' implicitly has an 'any' type.
            responseJson.data.forEach((staffMember) => {
                staffMember.displayText = staffMember.fullName;
                if (staffMember.studentId) {
                    staffMember.displayText += ` (${staffMember.studentId})`;
                }
            });
            return { options: responseJson.data };
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'message' implicitly has an 'any' type.
    onError(message) {
        this.setState({ errors: [...this.state.errors, message] });
    }
    // @ts-expect-error - TS7006 - Parameter 'coordinator' implicitly has an 'any' type.
    onCoordinatorChange(coordinator) {
        if (coordinator) {
            this.setState({ selectedCoordinator: coordinator });
        }
        else {
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type '{ personId: string; displayText: string; }'.
            this.setState({ selectedCoordinator: null });
        }
    }
    fetchEarlyAlertReasons() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/earlyAlertReason/list?format=json&max=-1", {
                credentials: "include",
            });
            const singleResponse = yield response.json();
            return singleResponse;
        });
    }
    validateForm() {
        const validationErrors = [];
        if (!this.state.selectedCoordinator) {
            validationErrors.push("Coordinator is required.");
        }
        return validationErrors;
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const validationErrors = this.validateForm();
                this.setState({ validationErrors });
                if (validationErrors && validationErrors.length) {
                    return;
                }
                this.setState({ isSaving: true });
                const response = yield fetch("/aviso/alertCoordinator/create", {
                    credentials: "include",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getXSRF(),
                    },
                    body: JSON.stringify({
                        alertId: this.props.alertId,
                        locationId: this.state.selectedLocation
                            ? // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                                this.state.selectedLocation.id
                            : null,
                        // @ts-expect-error - TS2531 - Object is possibly 'null'.
                        personId: this.state.selectedCoordinator.personId,
                        earlyAlertReasonId: this.state.selectedEarlyAlertReason
                            ? // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                                this.state.selectedEarlyAlertReason.id
                            : null,
                    }),
                });
                const responseJson = yield response.json();
                if (responseJson.success) {
                    // Call the onSave function on the props.
                    if (this.props.onSave) {
                        this.props.onSave();
                    }
                    // Clear the fields on the form.
                    this.setState({
                        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'LookupItem[]'.
                        selectedLocation: null,
                        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type '{ personId: string; displayText: string; }'.
                        selectedCoordinator: null,
                        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'LookupItem[]'.
                        selectedEarlyAlertReason: null,
                    });
                }
                else {
                    this.onError(responseJson.message);
                }
            }
            catch (all) {
                this.onError(ErrorService.getMessageFromError(all));
            }
            finally {
                this.setState({ isSaving: false });
            }
        });
    }
    renderValidationErrors() {
        if (!this.state.validationErrors || !this.state.validationErrors.length) {
            return null;
        }
        return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("div", { children: "Please correct the following problems:" }), _jsx("ul", { children: this.state.validationErrors.map((message, index) => (_jsx("li", { children: message }, index))) })] }));
    }
    render() {
        return (_jsx("div", { id: "newCoordinatorModal", className: "modal fade", role: "dialog", children: _jsx("div", { className: "modal-dialog", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h4", { className: "modal-title", children: _jsx("span", { className: "js-email-preview-title", children: "New Alert Coordinator" }) }), _jsx("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }), _jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "student-campus-location", children: "Student Campus Location" }), _jsx(DeprecatedSelect.Async, { loadOptions: this.fetchLocations, valueKey: "id", labelKey: "name", id: "student-campus-location", "aria-label": "Student Campus Location", placeholder: "Start typing...", value: this.state.selectedLocation, onChange: this.onLocationChange }), _jsxs("div", { className: "alert alert-info mt-2", children: [_jsx("span", { className: "fa fa-info-circle", "aria-hidden": "true" }), " ", "Leaving Student Campus Location blank will add a coordinator for all locations."] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "staff-initiated-alert-reason", children: "Staff Initiated Alert Reason" }), _jsx(DeprecatedSelect, { labelKey: "name", id: "staff-initiated-alert-reason", "aria-label": "Staff Initiated Alert Reason", isLoading: this.state.isLoadingEarlyAlertReasons, onChange: this.onEarlyAlertReasonChange, 
                                            // @ts-expect-error - TS2339 - Property 'earlyAlertReasons' does not exist on type '{ selectedEarlyAlertReason: null; selectedLocation: null; selectedCoordinator: null; errors: never[]; isLoadingEarlyAlertReasons: boolean; isSaving: boolean; validationErrors: never[]; }'.
                                            options: this.state.earlyAlertReasons, placeholder: "Start typing...", value: this.state.selectedEarlyAlertReason, valueKey: "id" }), _jsxs("div", { className: "alert alert-info mt-2", children: [_jsx("span", { className: "fa fa-info-circle", "aria-hidden": "true" }), " ", "Leaving Staff Initiated Alert Reason blank will add a coordinator for all reasons."] })] }), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "coordinator", children: "Coordinator" }), _jsx(DeprecatedSelect.Async, { id: "coordinator", "aria-label": "Coordinator", loadOptions: this.fetchStaff, valueKey: "personId", labelKey: "displayText", placeholder: "Start typing...", value: this.state.selectedCoordinator, onChange: this.onCoordinatorChange })] }), this.renderValidationErrors(), _jsx(Errors, { errors: this.state.errors })] }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { type: "button", className: "btn btn-primary", onClick: this.save, disabled: this.state.isSaving, children: [this.state.isSaving ? (_jsx(Busy, {})) : (_jsx("span", { className: "fa fa-plus", "aria-hidden": "true" })), " ", "Add"] }), _jsxs("button", { type: "button", className: "btn btn-outline-secondary", "data-dismiss": "modal", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Close"] })] })] }) }) }));
    }
}
